const products = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 78,
    image: "/imgs/products/f1.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 2,
    name: "Casual T-Shirt",
    price: 45,
    image: "/imgs/products/f2.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 3,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 65,
    image: "/imgs/products/f3.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 4,
    name: "Casual T-Shirt",
    price: 55,
    image: "/imgs/products/f4.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 5,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 82,
    image: "/imgs/products/f5.jpg",
    brand: "Fashion",
    rating: 4
  },
  {
    id: 6,
    name: "Casual T-Shirt",
    price: 48,
    image: "/imgs/products/f6.jpg",
    brand: "Casual",
    rating: 5
  },
  {
    id: 7,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 75,
    image: "/imgs/products/f7.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 8,
    name: "Casual T-Shirt",
    price: 52,
    image: "/imgs/products/f8.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 9,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 88,
    image: "/imgs/products/n1.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 10,
    name: "Casual T-Shirt",
    price: 58,
    image: "/imgs/products/n2.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 11,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 79,
    image: "/imgs/products/n3.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 12,
    name: "Casual T-Shirt",
    price: 62,
    image: "/imgs/products/n4.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 13,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 76,
    image: "/imgs/products/n5.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 14,
    name: "Casual T-Shirt",
    price: 54,
    image: "/imgs/products/n6.jpg",
    brand: "Casual",
    rating: 4
  },
  {
    id: 15,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    price: 81,
    image: "/imgs/products/n7.jpg",
    brand: "Fashion",
    rating: 5
  },
  {
    id: 16,
    name: "Casual T-Shirt",
    price: 60,
    image: "/imgs/products/n8.jpg",
    brand: "Casual",
    rating: 4
  }
];

export default products;